import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LOGO_URL } from "@/lib/constants";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/login");
      return;
    }
    googleSession(sid)
      .then((u) => {
        window.history.replaceState(null, "", "/");
        navigate(u && !u.profile_complete ? "/complete-profile" : "/");
      })
      .catch(() => {
        window.history.replaceState(null, "", "/");
        navigate("/login");
      });
  }, [googleSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center bg-[#050505]">
      <div className="text-center">
        <img src={LOGO_URL} alt="OnchainLyfe" className="h-9 mx-auto mb-6" />
        <div className="flex items-center gap-2 justify-center">
          <span className="live-dot w-2 h-2 rounded-full bg-[#ccff00]" />
          <p className="font-mono-cl text-xs tracking-[0.24em] text-[#ccff00] uppercase">Signing you in…</p>
        </div>
      </div>
    </div>
  );
}
